import { Button, Col, Divider, Row, Table } from "antd";
import { useCoursesSummary } from "./useCoursesSummary";
import Title from "antd/es/typography/Title";
import Paragraph from "antd/lib/typography/Paragraph";
import CustomModal from "../shared/Modal/Modal";
import SearchInput from "../shared/search-input/search-input";
import { useEffect, useState } from "react";
import { DataType } from "../../interfaces/my-courses-summary.interface";
import { CloseOutlined, DownloadOutlined } from "@ant-design/icons";
import { downloadLetterCertificateFile } from "../../services/my-courses-summary.service";

const MyCoursesSummary = () => {
  const { dataset, columns, openModal, setOpenModal, options } =
    useCoursesSummary();

  const [data, setData] = useState<DataType[]>();

  const searchHandler = (value: any) => {
    if (value.target.value)
      setData(
        dataset?.filter(
          (v: any) =>
            Object.keys(v).filter((key) =>
              v[key]
                .toString()
                .toLowerCase()
                .includes(value.target.value.toString().toLowerCase()),
            ).length > 0,
        ),
      );
    else setData(dataset);
  };

  useEffect(() => {
    setData(dataset);
  }, [dataset]);

  return (
    <div
      className="flex flex-col justify-center max-w-6xl p-4"
      style={{ margin: "0 auto" }}
    >
      <div className="text-end">
        <SearchInput onSearch={searchHandler} cssClasses="w-60" />
      </div>
      <div className="pt-6">
        <Table columns={columns} dataSource={data} bordered size="middle" />
      </div>

      <CustomModal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        titleComponent={
          <Row>
            <Col span={16} offset={4} className="text-center">
              <Row>
                <Col span={24}>
                  <img src={options?.img} className="max-h-20" />
                </Col>
              </Row>
              <div className="flex justify-center items-center gap-5">
                <Title
                  className="m-0 justify-center items-center"
                  level={3}
                  style={{ fontWeight: "500" }}
                >
                  Printing:
                  {options?.type === "certificate"
                    ? "Certificate of Completion"
                    : "Course Audit Certification Letter"}
                </Title>
              </div>
            </Col>
            <Divider></Divider>
          </Row>
        }
      >
        <Row>
          <Col span={16} offset={4} className="text-center">
            <Paragraph strong>
              {options?.type === "certificate"
                ? "Congratulations on passing this course."
                : "Congratulations on auditing this course."}
            </Paragraph>
            <Paragraph>
              {options?.type === "certificate"
                ? "You can now print your Course Completion Certificate."
                : "You can now print a letter certifying that you have audited this class."}
            </Paragraph>
          </Col>
          <Divider></Divider>
        </Row>

        <Row>
          <Col span={16} offset={4} className="text-center">
            <Paragraph>
              <strong>Important note: </strong> Please make sure your name and
              address are correct. You can edit your personal information in
              your "My SEABC Profile".
            </Paragraph>
          </Col>
          <Divider></Divider>
        </Row>

        <Row>
          <Col span={16} offset={4} className="text-center">
            <Button
              style={{ height: "2.3rem" }}
              htmlType="submit"
              type="primary"
              onClick={() =>
                downloadLetterCertificateFile(
                  options?.courseId ?? 0,
                  options?.type ?? "",
                )
              }
              icon={<DownloadOutlined />}
            >
              Download
            </Button>
            <Button
              style={{ height: "2.3rem" }}
              type="primary"
              danger
              icon={<CloseOutlined />}
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </CustomModal>
    </div>
  );
};

export default MyCoursesSummary;
